import { Injectable } from '@angular/core';
import { HttpService } from 'src/core/http/http.service';
import { IAppConfig } from 'src/config/app-config.model';
import { AppConfig } from 'src/config/app-config.service';

@Injectable({
  providedIn: 'root'
})
export class HomeService {

  appSettings: IAppConfig;

  constructor(private httpService: HttpService) {
    this.appSettings = AppConfig.settings;
  }

  isRepresentative() {
    let url = this.appSettings.authenticationApi + '/representativeAuth/IsRepresentative'
    return this.httpService.get<boolean>(url);
  }
  
}
